import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CalibrationInvoiceDetailResponse,
  CalibrationConfirmInvoiceApiResponse,
  CalibrationConfirmInvoiceDeviceModel,
  CalibrationConfirmInvoiceModel
} from 'src/app/Interface/CalibrationConfirmInvoice_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalibrationConfirmInvoiceService {
  private readonly url = environment.BaseUrl + 'Daro/CalibrationConfirmInvoice';

  constructor(private http: HttpClient) { }

  GetPending(Done:boolean): Observable<CalibrationConfirmInvoiceModel[] | CalibrationConfirmInvoiceApiResponse<CalibrationConfirmInvoiceModel[]>> {
    return this.http.get<CalibrationConfirmInvoiceModel[] | CalibrationConfirmInvoiceApiResponse<CalibrationConfirmInvoiceModel[]>>(
      `${this.url}/GetPending?Done=${Done}`
    );
  }

  GetDetail(id: number): Observable<CalibrationConfirmInvoiceDeviceModel[] | CalibrationConfirmInvoiceApiResponse<CalibrationConfirmInvoiceDeviceModel[]>> {
    return this.http.get<CalibrationConfirmInvoiceDeviceModel[] | CalibrationConfirmInvoiceApiResponse<CalibrationConfirmInvoiceDeviceModel[]>>(
      `${this.url}/GetDetail?id=${id}`
    );
  }

  GetInvoiceDetail(id: number): Observable<CalibrationInvoiceDetailResponse> {
    return this.http.get<CalibrationInvoiceDetailResponse>(
      `${this.url}/GetDetail?id=${id}&includeInvoiceSummary=true`
    );
  }

  GetConfirmed(factorConfirmFilter: number = 0): Observable<CalibrationConfirmInvoiceModel[] | CalibrationConfirmInvoiceApiResponse<CalibrationConfirmInvoiceModel[]>> {
    return this.http.get<CalibrationConfirmInvoiceModel[] | CalibrationConfirmInvoiceApiResponse<CalibrationConfirmInvoiceModel[]>>(
      `${this.url}/GetConfirmed?FactorConfirmFilter=${factorConfirmFilter}`
    );
  }

  ConfirmFactor(calibrationId: number): Observable<unknown> {
    return this.http.post(`${this.url}/ConfirmFactor?id=${calibrationId}`, {});
  }

  SaveDetail(model: CalibrationConfirmInvoiceDeviceModel, scopeCalibrationId: number): Observable<unknown> {
    
    return this.http.post(`${this.url}/SaveDetail`, { ...model, scopeCalibrationId });
  }

  Confirm(id: number, expectedFinalTotal?: number): Observable<unknown> {
    return this.http.post(`${this.url}/Confirm?id=${id}`, { expectedFinalTotal });
  }
}
